import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaMoneyBillWaveAlt, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./corte.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../utils/constants/services';
import Select from 'react-select'
import { useAsync } from 'react-select/async';

export default function CorteModal(props) {
    const { show, setShow, handleUpdate, tipo, sucursalSelect, fecha } = props;
    const { clientActual, userId, permisos } = useAuth();
    const [total, setTotal] = useState("");
    const [showPago, setShowPago] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [description, setDescription] = useState([]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const columns = [
        {
            name: '#',
            selector: row => row.number,
            width: "80px"
        },
        {
            name: 'Monto',
            selector: row => `$ ${row.amount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
        },
        {
            name: 'Descripción',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.4'
                }}>
                    {row.description}
                </div>
            ),
            wrap: true,
            minWidth: '250px'
        },
        {
            name: 'Fecha',
            selector: row => row.date.split("T")[0],
            
        },
        {
             name: 'Acciones',
            cell: row => (
                <div >
                   {(permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) && (
                       <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.id)}><MdDelete /></button>
                   )}
                </div>
            ),
            wrap: true,
            minWidth: '250px'
            
        },


    ];
    const handleUpdatepdateTable = () => {
        api(SERVICE.getPagoCorte + `?date=${fecha}&centralOfficeId=${sucursalSelect.value}`)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        if(tipo===1 && element.type==="Contributions"){
                            arrayTemp.push({...element,number:(index+1)});
                        }
                        else if(tipo===2 && element.type==="Deductions"){
                            arrayTemp.push({...element,number:(index+1)});
                        }
                    }
                    
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleDelete = (id) => {
        // Verificar si tiene permisos para editar corte
        const tienePermisoEditar = permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1;
        
        if (!tienePermisoEditar) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Sin permisos",
                text: "No tiene permisos para eliminar " + (tipo === 1 ? "aportaciones" : "deducciones"),
                showConfirmButton: true
            });
            return;
        }

        Swal.fire({
                    title: "Esta segur@ que desea eliminar la " + (tipo === 1 ? "aportación" : "deducción") + "?",
                    showCancelButton: true,
                    confirmButtonText: "Eliminar",
                    denyButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        api(SERVICE.eliminarItems + `?Id=${id}`, {}, "DELETE")
                            .then((data) => {
                                handleUpdate();
                                handleUpdatepdateTable();
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    }
                });
    }

    const handlePagar = () => {
        if (fecha !== null && fecha !== "" && total && parseInt(total) > 0 && description !== "") {
            Swal.fire({
                title: "<div>Se Realizará " + (tipo === 1 ? "una aportación" : "un gasto") + " por la cantidad de <b>$ " + parseInt(total).toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + "</b></div>",
                showCancelButton: true,
                confirmButtonText: "INGRESAR",
                confirmButtonColor: "#079459",
                cancelButtonText: "CANCELAR"
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        let payload = {
                            "Amount": total,
                            "Type": tipo === 1 ? "Contributions" : "Deductions",
                            "Description": description,
                            "Date": fecha,
                            "userId": userId,
                            "CentralOfficeId": sucursalSelect.value
                        }
                        api(SERVICE.setPagoCorte, payload, "POST")
                            .then((data) => {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: tipo === 1 ? "Aportación ingresada" : "Gasto ingresado" + " correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                handleUpdate();
                                handleUpdatepdateTable();
                                setTotal("");
                                setDescription("");
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    }
                })
        }
        else {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        // if (fecha != null && fecha != "") {
        //     Swal.fire({
        //         title: "<div>Se Realizará un pago por la cantidad de <b>$ " + total.toLocaleString('es-MX', {
        //             minimumFractionDigits: 2,
        //             maximumFractionDigits: 2
        //         }) + "</b></div>",
        //         showCancelButton: true,
        //         confirmButtonText: "PAGAR",
        //         confirmButtonColor: "#079459",
        //         cancelButtonText: "CANCELAR"
        //     }).then((result) => {
        //         /* Read more about isConfirmed, isDenied below */
        //         if (result.isConfirmed) {

        //             let payload = [];
        //             debugger;

        //             for (let index = 0; index < paymentsIds.length; index++) {
        //                 const element = paymentsIds[index];
        //                 const fechaCompare = new Date(element.date);
        //                 const hoy = new Date(fecha + 'T00:00');
        //                 fechaCompare.setHours(0, 0, 0, 0);
        //                 hoy.setHours(0, 0, 0, 0);
        //                 let tipoPago = "";
        //                 if (liquidar) {
        //                     tipoPago = "PAGTOTAL";
        //                 }
        //                 else {
        //                     if (fechaCompare < hoy) {
        //                         tipoPago = "PAGATR";
        //                     }
        //                     else if (fechaCompare > hoy) {
        //                         tipoPago = "PAGADE";
        //                     }
        //                     else {
        //                         tipoPago = "PAG";
        //                     }
        //                 }
        //                 if(element.montoPago < element.amount){
        //                     tipoPago = "PAGABON";
        //                 }

        //                 payload.push(
        //                     {
        //                         "TypePaymentIdentifier": tipoPago,
        //                         "AmortizationTableId": element.id,
        //                         "Amount": element.montoPago,
        //                         "Date": fecha,
        //                         "UserId": userId,
        //                     }
        //                 );

        //             }
        //             api(SERVICE.setPago, payload, "POST")
        //                 .then((data) => {
        //                     Swal.fire({
        //                         position: "center",
        //                         icon: "success",
        //                         title: "Pagos realizados correctamente",
        //                         showConfirmButton: false,
        //                         timer: 1500
        //                     });
        //                     handleUpdatepdateTable();
        //                     handleUpdate();
        //                     handleUpdateByTotal(total);
        //                     //setUpdate(update+1);
        //                 })
        //                 .catch((err) => {
        //                     console.log(err);
        //                 })
        //         }
        //     });

        // }
        // else {
        //     Swal.fire({
        //         text: 'Favor de llenar todos los campos',
        //         icon: 'error',
        //         confirmButtonText: 'Aceptar'
        //     })
        // }

    }
    useEffect(()=>{
        if(show){
            handleUpdatepdateTable();
        }
        else{
            setTotal("");
            setDescription("");
        }
    },[show])

    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none", width: (showPago && permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) ? "1100px" : "800px" }}>
                    <div className={styles.headerForm}>
                        <h5>{tipo === 1 ? "Aportaciones" : "Deducciones (gastos)"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerForm} style={{ paddingTop: "15px" }}>

                        <div className={styles.itemForm} style={{ width: (showPago && permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) ? "70%" : "100%" }}>
                            {(permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) && (
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <button className='btn btn-success' onClick={() => setShowPago(!showPago)}>{tipo === 1 ? "Ingresar aportación" : "Ingresar gasto"}&nbsp;&nbsp;<FaMoneyBillWaveAlt ></FaMoneyBillWaveAlt></button>
                                </div>
                            )}
                            <div className={styles.tableContainer}>

                                <DataTable
                                    columns={columns}
                                    data={dataTable}
                                    customStyles={APP_OPTIONS.TABLE_SETTING2}
                                    persistTableHead
                                    fixedHeader
                                    fixedHeaderScrollHeight='500px'
                                    responsive
                                />

                            </div>

                        </div>
                        {(permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) && (
                            <div className={styles.itemForm} style={{ width: "30%", display: showPago ? "" : "none", borderStyle: "solid", paddingLeft: "10px", borderWidth: "0px 0px 0px 2px" }}>
                                <div className={styles.containerForm}>
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <h4>{tipo === 1 ? "Ingresar aportación" : "Ingresar gasto"}</h4>
                                </div>
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <label class="form-label">Fecha:</label>
                                    <input disabled type="date" class="form-control" placeholder="Fecha Inicio" value={fecha} />
                                </div>
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <label class="form-label">Monto total:</label>
                                    <input type="number" class="form-control" placeholder="$" value={total} onChange={(e) => setTotal(e.target.value)} />
                                </div>
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <label class="form-label">Descripción:</label>
                                    <textarea type="text" rows="3" className='form-control' placeholder="" value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                                </div>
                                <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <label class="form-label">Cantidad a ingresar:</label>
                                    <div className={styles.monto}>{`$ ${total ? parseInt(total).toLocaleString('es-MX', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) : " 0.00"}`}</div>
                                </div>
                                <div className={styles.itemForm} style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <button className='btn btn-success' onClick={() => handlePagar()}>INGRESAR&nbsp;&nbsp;<FaMoneyBillWaveAlt ></FaMoneyBillWaveAlt></button>

                                </div>


                            </div>
                        </div>
                        )}



                    </div>
                </div>
            </div>
        </>
    );
}